import {DqResponseTO} from 'generated/JavaTO'
import {DqElement} from 'module/Dq/searchDq'
import _ from 'lodash'
import {DqResponse} from 'generated/JavaTOmodifications'

const dqSearchableMap: { [dqkey in string]?: boolean } = {}
export function isDqSearchable(dqkey: string): boolean {
	return dqSearchableMap[dqkey] !== false
}

function parseDqElementsFromServer(elements: DqResponseTO['elements']): DqElement[] {
	return elements.map(x => {
		const o: DqElement = {...x}
		if (x.hasOwnProperty('hidden')) {
			o.hidden = !(!x.hidden || x.hidden === 'N' || x.hidden === 'false' || parseInt(x.hidden as unknown as string) === 0)
		}
		if (x.hasOwnProperty('disabled')) {
			o.disabled = !(!x.disabled || x.disabled === 'N' || x.disabled === 'false' || parseInt(x.disabled as unknown as string) === 0)
		}
		if (x.hasOwnProperty('sortnr')) {
			o.sortnr = parseInt(x.sortnr as unknown as string) || 0
		}
		return o
	})
}

export function parseDqResponseTO(r: DqResponseTO): DqResponse {
	let paginated = false
	dqSearchableMap[r.id] = r.searchable
	let elements = parseDqElementsFromServer(r.elements)
	if (r.elements.length < r.count) {
		paginated = true
	}
	if (paginated) {
		elements.push({label: 'Weitere Einträge verfügbar...', isDisabled: true, disabled: true, sortnr: Infinity})
	}
	return {...r, elements}
}

/**
 * @param response Record<string, string>[] is deprecated, use DqResponseTO instead!
 * @param dataId deprecated!
 * @param dataText deprecated!
 */
export function parseDqResponseTO_deprecated(response: DqResponseTO | Record<string, string>[], dataId: string = 'value', dataText: string = 'label') {
	let paginated = false
	let elements: DqResponseTO['elements'];
	if (response && response.hasOwnProperty('count') && response.hasOwnProperty('elements')) {
		const r = response as DqResponseTO
		dqSearchableMap[r.id] = r.searchable
		elements = r.elements
		if (elements.length < r.count) {
			paginated = true
		}
	} else {
		elements = response as any[]
	}

	let data: DqElement[]
	if (dataId === 'value' && dataText === 'label') {
		data = parseDqElementsFromServer(elements)
	} else {
		// deprecated method of mapping any url result to dq
		data = _.map(elements, (e: any) => {
			let text;
			if (_.isArray(dataText)) {
				text = _.map(dataText, function (text) {
					return e[text]
				}).join(" ")
			} else {
				text = e[dataText]
			}
			let val = e[dataId]
			return {
				value: val,
				label: text,
			}
		})
	}
	if (paginated) {
		data.push({label: 'Weitere Einträge verfügbar...', isDisabled: true, disabled: true, sortnr: Infinity})
	}
	return data
}
